var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "11px",
    viewBox: "0 0 15 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Check") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card-/-SMS-Alerts-/-Desktop-/-Success",
    transform: "translate(-48.000000, -366.000000)",
    fill: "#2FB3B4",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "check-mint",
    transform: "translate(48.000000, 366.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4626229,0.538043043 C14.1023641,0.165528207 13.5266944,0.165503079 13.1667489,0.537980436 L5.48559419,8.4800219 L5.0163779,7.99481752 L1.83350901,4.70349548 C1.47296684,4.33098967 0.897503669,4.33108019 0.537210584,4.70361517 C0.165788648,5.08796866 0.165762005,5.71929853 0.537032607,6.1034955 L4.83610578,10.5487628 C5.19711605,10.9214502 5.77336526,10.9215005 6.13379462,10.5491112 L14.4629804,1.93774278 C14.8343213,1.55338979 14.8341558,0.921904309 14.4626229,0.538043043 Z",
    id: "Fill-11"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.ef395deb1cdf8a0c6f106576545a6d5d.svg";
export { ForwardRef as ReactComponent };